import { useDropzone } from "react-dropzone";
import Button from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Grid } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  DocumentUrl,
  DocumentsDelete,
} from "../../models/supplierSettlement/supplierSettlement.model";
import { useMutation, useQueryClient } from "react-query";
import { IDENTITY_SUPPLIER_ATTACHMENTS } from "../../config/cacheKey";
import { IdentityDocumentDelete } from "../../services/supplierSettlement/identityService";
import ModalCancelUploaderImage from "../modals/ModalCancelUploaderImage";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import useDownloader from "react-use-downloader";

export default function LoadDocumentCmp(props: any) {
  const { download } = useDownloader();
  let type;
  let isImg =
    props.data.fileType?.includes("Image") ||
    props.data.fileType?.includes("image");
  const fileUrl = props.data.fileUrl;
  const queryClient = useQueryClient();
  const filename = `${type}`;
  const handleDownloda = () => {
    download(fileUrl, filename);
    window.open(fileUrl);
  };
  const deleteDocument = useMutation(props.serviceName, {
    onSuccess: async (data: boolean) => {
      if (data) {
        if (props.cacheName != undefined) {
          let supplierAttachments = queryClient.getQueryData<DocumentUrl[]>(
            props.cacheName
          );
          supplierAttachments?.map((item: any) => {
            if (item.fileId === props.data.fileId) {
              item.fileUrl = undefined;
              return;
            }
          });
          queryClient.setQueryData(props.cacheName, supplierAttachments);
          props.setChildValue(queryClient.getQueryData(props.cacheName));
        } else if (props.attachments != undefined) {
          let attachmentsTemprory = props.attachments.filter(
            (x: { fileId: any }) => x.fileId != props.data.fileId
          );
          props.setChildValue(attachmentsTemprory);
        } else {
          props.setChildValue(undefined);
        }
      }
    },
    onError: (err) => {},
  });

  const deleteImage = () => {
    if (props.serviceRequestObj != undefined) {
      deleteDocument.mutate(props.serviceRequestObj);
    } else if (props.multiItem != undefined && props.multiItem) {
      let supplierAttachments = props.attachments?.filter(
        (item: any) => item.fileUrl != props.data.fileUrl
      );

      props.setChildValue(supplierAttachments);
    } else {
      props.setChildValue(undefined);
    }
  };

  return (
    <div
      className="UploadImageCmp"
      style={{ width: props.width ? props.width : "" }}
    >
      <a href={`${props.data.fileUrl!}/true`} target="_blank">
        {isImg ? (
          <img
            style={{ padding: "1vh" }}
            // , width: "inherit !important"
            src={props.data.fileUrl ? props.data.fileUrl : ""}
            className="uploadImage verticalForuploadImage"
          />
        ) : (
          <span
            onClick={handleDownloda}
            className="uploadImage verticalForuploadImage"
            style={{
              padding: "1vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <InsertDriveFileOutlinedIcon className="uploadImageIcon" />
          </span>
        )}
      </a>

      <Grid
        className="row rowUploadImage"
        container
        xs={12}
        alignItems={"center"}
      >
        <Grid item xs={10}>
          <div
            style={{ color: "#fff", marginRight: "10px", overflow: "hidden" }}
          >
            <p className="paraghramImage ">
              {props.data.documentTypeTitle
                ? props.data.documentTypeTitle
                : props.picName}
            </p>
          </div>
        </Grid>
        <Grid item xs={2} style={{ paddingBottom: "10px" }}>
          <ModalCancelUploaderImage
            title={""}
            bgColor={"kamanColor"}
            setValue={deleteImage}
            dontShowDeleteIcon={props.dontShowDeleteIcon}
          />
        </Grid>
      </Grid>
    </div>
  );
}
